import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { NaacSubHeadingRoutingModule } from './naac-sub-heading-routing.module';
import { NaacSubHeadingListComponent } from './naac-sub-heading-list/naac-sub-heading-list.component';
import { NaacSubHeadingCreateComponent } from './naac-sub-heading-create/naac-sub-heading-create.component';

@NgModule({
  declarations: [NaacSubHeadingListComponent, NaacSubHeadingCreateComponent],
  imports: [
    CommonModule,
    NaacSubHeadingRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class NaacSubHeadingModule { }
